import { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';

import Container from '@/components/@base/container';
import { Input } from '@/components/@base/input';
import { Text } from '@/components/@base/typography';

import { pageLevelLocalization } from '@/constant/localization';
import Props from '@/components/app/auth/components/@shared/2fa/type';
const { login: loginLocalization } = pageLevelLocalization;

export default function TwoFactor({ handleInputChange, error }: Props) {
  const [twoFa, setTwoFa] = useState('');
  useEffect(() => {
    handleInputChange('twoFactor', twoFa);
  }, [twoFa]);

  return (
    <Container>
      <Text className='py-4 text-[16px] text-[#424244]'>
        {loginLocalization.enterTwoFactorCode}:
      </Text>
      <Container dir='ltr' className='w-full'>
        <OTPInput
          value={twoFa}
          onChange={setTwoFa}
          numInputs={6}
          inputType='number'
          containerStyle='flex justify-center gap-[4px] sm:gap-3'
          renderInput={(props) => (
            <Input
              {...props}
              containerClassName='max-w-[48px] min-w-[40px] flex-1'
              className='aspect-square h-auto min-h-0 w-full! px-0 text-center text-xl sm:text-2xl'
            />
          )}
        />
      </Container>
      {error ? <div className='mt-1 text-sm text-red-600'>{error}</div> : null}
    </Container>
  );
}
